// extracted by mini-css-extract-plugin
export var content = "_6t-1";
export var modal = "_6t-0";